import { useEffect, useState } from 'react';
import { PAGING_SETTINGS } from '../config/constant';
import useSessionStorage from './useSessionStorage';

const { POSTS_PER_PAGE, DEFAULT_PAGE } = PAGING_SETTINGS;

function usePaging(namespace, total, postsPerPage = POSTS_PER_PAGE) {
  const [getSessionStorage, saveToSessionStorage] = useSessionStorage();
  const [page, setPage] = useState(Math.ceil(total / postsPerPage));

  const isLastPage = !(postsPerPage * page <= total);
  const loadMore = () => {
    setPage((prev) => prev + 1);
  };

  useEffect(() => {
    setPage(getSessionStorage(`${namespace}-page`, DEFAULT_PAGE));
  }, [namespace, getSessionStorage]);

  useEffect(() => {
    saveToSessionStorage(`${namespace}-page`, page);
  }, [page, namespace, saveToSessionStorage]);

  return [page, isLastPage, loadMore];
}

export default usePaging;
